import { useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { registerLastMailSelector } from "store/user/auth/user_auth.selector";

//
//component
//redux
//selector
//actions
export const TriggerCountdown = ({ setCountdown }) => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const lastMail = useSelector(registerLastMailSelector);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    if (lastMail) {
      const time = moment(lastMail).add(2, "minutes").valueOf();
      setCountdown(time);
    }
  }, [lastMail]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerCountdown;
